import React from "react";
import {css} from "@emotion/react";

import {color, mt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    onClick: () => void;
    label?: string;
}

export const ArticleActionButton: React.FC<IProps> = ({children, label, onClick}) => {
    return (
        <button css={articleButtonIcon} onClick={onClick}>
            {children}
            {!!label && (
                <Text variant="body_copy_2" css={[mt(0.5), color("#23232d")]}>
                    {label}
                </Text>
            )}
        </button>
    );
};

const articleButtonIcon = css`
    background: none;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    &:focus {
        outline: 0;
    }
`;
